<template>
    <div class="content">
        <h3>Регламент о порядке и условиях работы с данными платформы
            Университетского консорциума исследователей больших данных.</h3>
        <ol>
            <li>Платформа разработана специалистами Лаборатории наук о больших данных и проблемах общества Томского государственного университета (далее  Лаборатория) в рамках Университетского консорциума исследователей больших данных (далее  Консорциум).</li>
            <li>Данные представляют собой информацию, автоматически собранную из социальных сетей алгоритмами Платформы, и доступную в личном кабинете участника Консорциума lk.opendata.university.</li>
            <li>Доступ к данным Платформы предоставляется только участникам Консорциума, заключивших соглашение о включении в Консорциум. Участниками Консорциума могут быть исследовательские группы и отдельные исследователи из университетов и других образовательных организаций.</li>
            <li>Целью сотрудничества участников Консорциума и Лаборатории является проведение совместных научных и прикладных исследований, в рамках которых осуществляется работа с данными.</li>
            <li>Ожидаемым результатом научного сотрудничества участников Консорциума является написание и публикация совместных научных статей в высокорейтинговых рецензируемых журналах с обязательным указанием в числе авторов принимавших участие в исследовании сотрудников Лаборатории.</li>
            <li>Совместные прикладные исследования участников Консорциума и Лаборатории могут быть нацелены на создание новых продуктов и заключение договоров на выполнение научно-исследовательских работ. Условия которых оговариваются в отдельном порядке.</li>
            <li>В учебных целях участникам Консорциума может быть предоставлен ограниченный функционал Платформы.</li>
            <li>Ответственным исполнителем, предоставляющим доступ к данным и контролирующим выполнение условий Регламента, является заведующий Лабораторией Гойко Вячеслав Леонидович (E-mail: goiko@data.tsu.ru).</li>
            <li>Лаборатория предоставляет техническую поддержку участникам Консорциума, а также принимает заявки на расширение функционала Платформы и проведение масштабных сборов данных после согласования с Ответственным исполнителем.</li>
            <li>Запрещается передача доступа к Платформе и собранных данных третьим лицам без согласования с Ответственным исполнителем.</li>
            <li>Участник Консорциума, нарушивший правила данного Регламента, теряет доступ к Платформе путем блокирования учетной записи участника и его данных в личном кабинете.</li>
        </ol>
        </div>
</template>

<script>
  export default {
    name: "LicenseAgreements"
  }
</script>

<style lang="sass" scoped>
    .content
        overflow: auto
        height: 100%
        ol
            margin: 0
            padding: 0
            counter-reset: myCounter
        li
            list-style: none
            text-align: justify
            &::before
                counter-increment: myCounter
                content: counter(myCounter)'.'
                font-weight: bold
                display: inline-block
                margin-right: 20px
        h3
            text-align: center
</style>
